import { useRef } from 'react';
import { ReactFormGenerator } from 'react-form-builder2';

import { useRecoilValue } from 'recoil';

import generatePdfForm from 'lib/helpers/generatePdfForm/generatePdfForm';
import { filestackPath, pm } from 'lib/helpers/utility';

import useDocumentActions from 'components/shared/DocumentEditor/lib/useDocumentActions';
import Popover from 'components/shared/Popovers/Popover/Popover';
import state from 'components/state';

import useDocActions from '../lib/useDocActions';

const DocumentActionsPopover = ({
  setViewDocument,
  isEditOpen,
  setIsEditOpen,
  patientId,
  form,
  options,
  cat,
  data,
  setDownloadLoading,
  setSelectedAppointment,
  handleConfirmationFile,
  practice,
  setPatientSelection,
  appointmentId,
  setSendFaxModal,
  isLocked,
  setShareWithPracticeModal
}) => {
  const permissions = useRecoilValue(state.permissions);

  const hasPermissions =
    (options?.enableDocumentEdit && pm(permissions, 'patient_documents_center.update')) ||
    (data?.patient_id === data?.uploader_id && options.isPatient);

  const { handleDownload } = useDocumentActions({
    data,
    file: filestackPath(data?.document_handle),
    patientId
  });

  const exportRef = useRef([]);

  const downloadDocument = async () => {
    setDownloadLoading(true);
    if (data?.form_id) {
      try {
        const blob = await generatePdfForm({
          json: data.json,
          form_json: data.form_json,
          name: data.name
        });

        const url = URL.createObjectURL(blob);
        const link = document.createElement('a');
        link.href = url;
        link.download = `${data.name}.pdf`;
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
      } catch (error) {
        console.error('Error generating PDF:', error);
      }
    } else {
      await handleDownload();
    }
    setDownloadLoading(false);
  };

  const {
    viewDoc,
    editDoc,
    deleteDoc,
    deleteInNote,
    downloadDoc,
    assignPatient,
    appointmentLinking,
    sendFax,
    shareWithPractice,
    shareWithPatient
  } = useDocActions({
    data,
    options,
    patientId,
    practice,
    setViewDocument,
    setIsEditOpen,
    handleConfirmationFile,
    setPatientSelection,
    setSelectedAppointment,
    setSendFaxModal,
    setShareWithPracticeModal,
    downloadDocument,
    isLocked,
    hasPermissions,
    cat
  });

  const shareDocCondition =
    options?.enableDocumentSharing && data?.uploader_id !== data?.patient_id && data?.patient_id;

  const popoverOptions = [
    viewDoc,
    data?.form_id && hasPermissions && editDoc,
    hasPermissions && !isLocked && (appointmentId ? deleteInNote : deleteDoc),
    !isEditOpen && downloadDoc,
    options?.enablePatientSelect && data?.uploader_id !== data?.patient_id ? assignPatient : null,
    options?.enableAppointmentLinking && appointmentLinking,
    (options?.enableSendAsFax || options?.enableShareWithPractice || shareDocCondition) && {
      label: 'Share document',
      icon: 'share-mono',
      children: [
        options?.enableSendAsFax && sendFax,
        options?.enableShareWithPractice && shareWithPractice,
        shareDocCondition && shareWithPatient
      ].filter(Boolean)
    }
  ].filter(Boolean);

  return (
    <>
      <Popover
        icon="context-menu-horizontal"
        className="mt-[2px] flex h-full w-full items-center justify-center"
        position="left"
        isFixed
        isBorder={false}
        options={popoverOptions}
      />
      {data?.form_id && !isEditOpen && (
        <div
          className="PrintForm print:!bg-white print:p-8"
          ref={exportRef}
          style={{ display: 'none' }}>
          <ReactFormGenerator
            answer_data={form?.json?.fields ? JSON.parse(form?.json?.fields) : {}}
            data={form?.form_json?.fields}
            submitButton={<div />}
            read_only={true}
          />
        </div>
      )}
    </>
  );
};

export default DocumentActionsPopover;
